import { useUrlLocalizer } from 'tradera-lang';
import routes from '../routes';

const urlGetters = toLocalizedUrl => ({
    start: () => toLocalizedUrl(routes.START),
    templates: () => toLocalizedUrl(routes.TEMPLATES),
    template: (templateId, fromPage) =>
        toLocalizedUrl(routes.TEMPLATE.replace(':templateId', templateId)) +
        (fromPage ? '?from=' + fromPage : ''),
    newTemplate: () =>
        toLocalizedUrl(routes.TEMPLATE.replace(':templateId', 'new')),
    newTemplateFromDraft: () =>
        toLocalizedUrl(routes.TEMPLATE.replace(':templateId', 'newFromDraft')),
    editTemplateProperties: (templateId, propertyNames) =>
        toLocalizedUrl(
            routes.EDIT_TEMPLATE_PROPERTIES.replace(
                ':templateId',
                templateId
            ).replace(':propertyNames', propertyNames)
        ),
    newDraft: () => toLocalizedUrl(routes.NEW_DRAFT),
    draft: draftId => toLocalizedUrl(routes.DRAFT.replace(':draftId', draftId)),
    draftSummary: draftId =>
        toLocalizedUrl(routes.DRAFT_SUMMARY.replace(':draftId', draftId)),
    editDraftProperties: (draftId, propertyNames) =>
        toLocalizedUrl(
            routes.EDIT_DRAFT_PROPERTIES.replace(':draftId', draftId).replace(
                ':propertyNames',
                propertyNames
            )
        ),
    published: itemId =>
        toLocalizedUrl(routes.PUBLISHED.replace(':itemId', itemId))
});

const useSyiUrls = () => {
    const { toLocalizedUrl } = useUrlLocalizer();
    const urls = urlGetters(toLocalizedUrl);
    return urls;
};

export default useSyiUrls;
